d
<template>
  <div class="animated fadeIn" style="overflow-y:hidden">

    <div class="row">
      <div class="col">
        <b-btn @click="filterModalShow = !filterModalShow" :disabled="showLoadingAnimation">Filter</b-btn>
        <span> By </span>
        <span v-if="searchObject.email.length > 0">[email]: {{searchObject.email}} </span>
        <span v-if="searchObject.accountNumber.length > 0">and [account number]: {{searchObject.accountNumber}} </span>
        <span v-if="searchObject.status.length > 0">and [status]: {{searchObject.status}} </span>
        <span v-if="searchObject.phoneNumber.length > 0">and [phone number]: {{searchObject.phoneNumber}} </span>
        <span v-if="searchObject.createdDate.length > 0">and [created date]: {{searchObject.createdDate}} </span>
        <span v-if="searchObject.demo !== false">and [isDemo]: {{searchObject.demo}} </span>
        <b-btn @click="clearFilters()" :disabled="showLoadingAnimation">Clear Filters</b-btn>
      </div>
    </div>

    <!-- Filter Modal Component -->
    <b-modal id="modal1" title="Filter" v-model="filterModalShow">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="emailInput">Email:</label></b-col>
        <b-col><input type="text" id="emailInput" placeholder="" v-model="searchObject.email"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="hoyaAccNumberInput">HOYA Account Number:</label></b-col>
        <b-col><input type="text" id="hoyaAccNumberInput" placeholder="" v-model="searchObject.accountNumber"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="statusInput">Status:</label></b-col>
        <b-col>
          <!-- <input type="text" id="statusInput" placeholder="" v-model="searchObject.status"> -->
          <b-dropdown id="ddown3" :text="searchObject.status" class="m-md-1">
            <b-dropdown-item href="#" @click="searchStatusSelected('')"></b-dropdown-item>
            <b-dropdown-item href="#" @click="searchStatusSelected('WAITING_FOR_APPROVAL')">WAITING_FOR_APPROVAL
            </b-dropdown-item>
            <b-dropdown-item href="#" @click="searchStatusSelected('ACTIVE')">ACTIVE</b-dropdown-item>
            <b-dropdown-item href="#" @click="searchStatusSelected('LOCK')">LOCK</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="phoneNumberInput">Phone Number:</label></b-col>
        <b-col><input type="text" id="phoneNumberInput" placeholder="" v-model="searchObject.phoneNumber"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="isDemoInput">Demo:</label></b-col>
        <b-col><input type="checkbox" id="isDemoInput" placeholder="" v-model="searchObject.demo"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="createdDateInput">Created Date (DD/MM/YYYY):</label></b-col>
        <b-col>
          <input type="text" id="createdDateInput" placeholder="" v-model="searchObject.createdDate">
        </b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="filter()">
          Filter
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="filterModalShow = !filterModalShow">
          Close
        </b-btn>
      </div>
    </b-modal>

    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination
          size="sm"
          :total-rows="totalRowsC"
          v-model="currentPage"
          :per-page="rowsPerPageC"
          hide-ellipsis
          :limit="paginationButtonsLimit"
          align="center"
          @change="pageChanged"
          :disabled="disabledPagination"
        >
        </b-pagination>
      </div>
      <div class="col" align="right">
        <span>Total Rows {{totalRowsC}}</span>
      </div>
    </div>

    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh
    </button>
    <button type="button" class="btn btn-primary" @click="showModifyUserModal()" :disabled="showLoadingAnimation">Edit
    </button>
    <button type="button" class="btn btn-primary" @click="generateClaimsReport()" :disabled="showLoadingAnimation">
      Generate Claims Report
    </button>
    <b-table hover small bordered :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked">
      <template slot="approved" slot-scope="row">
        <span>{{row.item.approved}}</span>
        <button v-if="row.item.approved == false" type="button" class="btn btn-primary" @click="showApproveModal()">
          Approve
        </button>
      </template>
      <template slot="status" slot-scope="row">
        <span>{{row.item.status}}</span>
        <button v-if="row.item.status != 'WAITING_FOR_APPROVAL'" type="button" class="btn btn-primary"
                @click="showChangeStatusModal()">Change
        </button>
      </template>
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..."
         style="margin-left:auto; margin-right:auto; display: block;"
         v-if="showLoadingAnimation">
    <p style="text-align: center"
       v-if="showLoadingError">
      Loading error:
    </p>
    <p style="text-align: center"
       v-if="showNoResult">
      No Result
    </p>

    <!-- Confirm Approve User Modal Component -->
    <b-modal id="modal1" title="Confirm Approve" v-model="showConfirmApproveModal">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col>
          <span><b>Confirm approve the user : {{selectedRowItem == null ? '' : selectedRowItem.email}}</b></span><br/>
          <span>*User cannot draw if status not approved yet</span>
        </b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="approveUser()">
          Confirm Approve
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeApproveModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

    <!-- Change status Modal Component -->
    <b-modal id="modal1" title="Change User Status" v-model="showChangeUserStatusModal">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col>
          <span><b>Change status for user: {{selectedRowItem == null ? '' : selectedRowItem.email}}</b></span><br/>
          <span>*User cannot draw if status is NOT ACTIVE</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="newCampaignStatus">New Status:</label></b-col>
        <b-col>
          <b-dropdown id="ddown3" :text="newStatus" class="m-md-1">
            <b-dropdown-item href="#" @click="newStatusSelected('ACTIVE')">ACTIVE</b-dropdown-item>
            <b-dropdown-item href="#" @click="newStatusSelected('LOCK')">LOCK</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="changeStatus()">
          Change
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeChangeStatusModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

    <!-- Edit user details Modal Component -->
    <b-modal id="modal3" title="Edit User" v-model="showEditUserModal">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col>
          <label for="editedName" class="col-form-label">Name:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedName" placeholder=""
                 v-model="editedUserName" required>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedEmail" class="col-form-label">Email:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedEmail" placeholder=""
                 v-model="editedEmail" disabled>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedAccNum" class="col-form-label">Account Number:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedAccNum" placeholder=""
                 v-model="editedAccountNumber" required>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedPhoneNum" class="col-form-label">Phone Number:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedPhoneNum" placeholder=""
                 v-model="editedPhoneNumber">
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedCompanyName" class="col-form-label">Company Name:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedCompanyName" placeholder=""
                 v-model="editedCompanyName">
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedCompanyRegisNum" class="col-form-label">Company Registration Number:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedCompanyRegisNum" placeholder=""
                 v-model="editedCompanyRegistrationNumber">
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedBankName" class="col-form-label">Bank Name:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedBankName" placeholder=""
                 v-model="editedBankName">
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedBankAccName" class="col-form-label">Bank Account Name:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedBankAccName" placeholder=""
                 v-model="editedBankAccountName">
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="editedBankAccNum" class="col-form-label">Bank Account Number:</label>
        </b-col>
        <b-col>
          <input type="text" class="form-control" id="editedBankAccNum" placeholder=""
                 v-model="editedBankAccountNumber">
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <label for="isDemoAccount" class="col-form-label">Is Demo Account:</label>
        </b-col>
        <b-col>
          <input type="checkbox" class="form-control" id="isDemoAccount" placeholder="" name="Is Demo Account"
                 v-model="editedIsDemoAccount">
          <!-- <input type="checkbox" :name="item" :value="item" v-model="eligibleOrderTypes"/> -->
        </b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="updateUser()">
          Change
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeEditUserModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  data () {
    return {
      currentPage: this.$store.state.usrstomod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      newStatus: '',
      filterModalShow: false,
      searchObject: {
        email: '',
        accountNumber: '',
        status: '',
        phoneNumber: '',
        createdDate: '',
        demo: false
      }
    }
  },
  created: function () {
    // we hook into the created lifecycle to start grabbing data from firestore
    this.$store.dispatch('usrstomod/showAllInvoices', {orderBys: 'createdDate'})
  },
  updated: function () {
    // console.log('VUEJS updated hook!')
    let tableElement = document.getElementsByTagName('table')[0]
    let tableOriginalWidth = tableElement.offsetWidth
    // console.log('table width: ' + tableOriginalWidth)

    let tableHeaders = document.getElementsByTagName('th')
    // console.log('tableHeaders: ' + tableHeaders.length)
    let tableBodyCells = document.getElementsByTagName('td')
    // console.log('tableBodyCells: ' + tableBodyCells.length)
    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      let totalColumnWidth = 0
      tableElement.style.width = (tableOriginalWidth * 4.5) + 'px'
      tableElement.style.maxWidth = (tableOriginalWidth * 4.5) + 'px'
      // console.log('Post Process: Updated table width to: ' + tableElement.offsetWidth)
      // let totalDiffs = 0
      for (let i = 0; i < tableHeaders.length; i++) {
        let headerWidth = tableHeaders[i].offsetWidth
        let cellWidth = tableBodyCells[i].offsetWidth
        // console.log(i + '-Header width: ' + headerWidth)
        // console.log(i + '-Cell width: ' + cellWidth)
        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px'
          // console.log('updated header width to: ' + tableHeaders[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px'
          // console.log('update cell width to: ' + tableBodyCells[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px'
        tableElement.style.maxWidth = totalColumnWidth + 'px'
        // console.log('Updated table width to: ' + tableElement.offsetWidth)
      }
    }
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('usrstomod/changePageNumber', this.currentPage)
      this.$store.dispatch('usrstomod/showAllInvoices', {orderBys: 'createdDate'})
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.usrstomod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('usrstomod/changePageNumber', this.currentPage)
        this.$store.commit('usrstomod/setRowsPerPage', intRows)
        this.$store.dispatch('usrstomod/showAllInvoices', {orderBys: 'createdDate'})
      }
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked')
      console.log('item: ' + item)
      this.selectedRowItem = item
      this.$store.commit('usrstomod/selectTableRow', this.selectedRowItem.email)
    },
    newStatusSelected: function (selectedStatus) {
      this.newStatus = selectedStatus
      console.log('selected new status: ' + this.newStatus)
    },
    searchStatusSelected: function (selectedStatus) {
      this.searchObject.status = selectedStatus
    },
    showApproveModal: function () {
      this.$store.commit('usrstomod/toggleShowConfirmApproveModal', true)
    },
    closeApproveModal: function () {
      this.$store.commit('usrstomod/toggleShowConfirmApproveModal', false)
    },
    showChangeStatusModal: function () {
      this.$store.commit('usrstomod/toggleShowChangeUserStatusModal', true)
    },
    closeChangeStatusModal: function () {
      this.$store.commit('usrstomod/toggleShowChangeUserStatusModal', false)
    },
    showModifyUserModal: function () {
      // load user data into editedUser object
      if (this.selectedRowItem) {
        this.$store.commit('usrstomod/setEditedName', this.selectedRowItem.name)
        this.$store.commit('usrstomod/setEditedEmail', this.selectedRowItem.email)
        this.$store.commit('usrstomod/setEditedAccountNumber', this.selectedRowItem.accountNumber)
        this.$store.commit('usrstomod/setEditedPhoneNumber', this.selectedRowItem.phoneNumber)
        this.$store.commit('usrstomod/setEditedCompanyName', this.selectedRowItem.companyName)
        this.$store.commit('usrstomod/setEditedCompanyRegistrationNumber', this.selectedRowItem.companyRegistrationNumber)
        this.$store.commit('usrstomod/setEditedBankName', this.selectedRowItem.bankName)
        this.$store.commit('usrstomod/setEditedBankAccountName', this.selectedRowItem.bankAccountName)
        this.$store.commit('usrstomod/setEditedBankAccountNumber', this.selectedRowItem.bankAccountNumber)

        if (this.selectedRowItem.demo) {
          this.$store.commit('usrstomod/setIsDemoAccount', this.selectedRowItem.demo)
        } else {
          this.$store.commit('usrstomod/setIsDemoAccount', false)
        }

        this.$store.commit('usrstomod/toggleShowEditUserModal', true)
      }
    },
    generateClaimsReport: function () {
      if (this.selectedRowItem) {
        this.$router.push(
          {
            name: 'UserClaimReport',
            params:
              {
                name: this.selectedRowItem.companyName,
                email: this.selectedRowItem.email,
                accountNumber: this.selectedRowItem.accountNumber,
                bankName: this.selectedRowItem.bankName,
                bankAccountName: this.selectedRowItem.bankAccountName,
                bankAccountNumber: this.selectedRowItem.bankAccountNumber
              }
          }
        )
      }
    },
    closeEditUserModal: function () {
      this.$store.commit('usrstomod/toggleShowEditUserModal', false)
    },
    approveUser: function () {
      if (this.selectedRowItem) {
        this.$store.dispatch('usrstomod/approveUser', {email: this.selectedRowItem.email})
      }
    },
    changeStatus: function () {
      if (this.selectedRowItem) {
        this.$store.dispatch('usrstomod/changeUserStatus', {
          email: this.selectedRowItem.email,
          newStatus: this.newStatus
        })
      }
    },
    refreshTable: function () {
      this.currentPage = 1
      this.$store.commit('usrstomod/changePageNumber', this.currentPage)
      this.$store.dispatch('usrstomod/showAllInvoices', {orderBys: 'createdDate'})
    },
    updateUser: function () {
      if (this.selectedRowItem) {
        this.$store.dispatch('usrstomod/updateUser')
      }
    },
    filter: function () {
      this.filterModalShow = false
      this.$store.dispatch('usrstomod/filterTable', this.searchObject)
    },
    clearFilters: function () {
      if (this.searchObject.email === '' && this.searchObject.accountNumber === '' &&
        this.searchObject.status === '' && this.searchObject.phoneNumber === '' &&
        this.searchObject.createdDate === '' && this.searchObject.demo === false) {
        return
      }
      this.searchObject.email = ''
      this.searchObject.accountNumber = ''
      this.searchObject.status = ''
      this.searchObject.phoneNumber = ''
      this.searchObject.createdDate = ''
      this.searchObject.demo = false
      this.currentPage = 1
      this.$store.commit('usrstomod/changePageNumber', this.currentPage)
      this.$store.dispatch('usrstomod/showAllInvoices', {orderBys: 'createdDate'})
    }
  },
  computed: {
    disabledPagination: function () {
      return this.$store.state.usrstomod.disabledPagination
    },
    tableRows: function () {
      // return this.$store.getters['usrstomod/getAll']
      return this.$store.state.usrstomod.all
    },
    tableHeaders: function () {
      return this.$store.getters['usrstomod/getHeaders']
    },
    totalRowsC: function () {
      return this.$store.state.usrstomod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.usrstomod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.usrstomod.rowsPerPage
    },
    showConfirmApproveModal: {
      get: function () {
        return this.$store.state.usrstomod.showConfirmApproveModal
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/toggleShowConfirmApproveModal', newValue)
      }
    },
    showChangeUserStatusModal: {
      get: function () {
        return this.$store.state.usrstomod.showChangeUserStatusModal
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/toggleShowChangeUserStatusModal', newValue)
      }
    },
    showEditUserModal: {
      get: function () {
        return this.$store.state.usrstomod.showEditUserModal
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/toggleShowEditUserModal', newValue)
      }
    },
    editedUserName: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.name
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedName', newValue)
      }
    },
    editedEmail: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.email
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedEmail', newValue)
      }
    },
    editedAccountNumber: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.accountNumber
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedAccountNumber', newValue)
      }
    },
    editedPhoneNumber: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.phoneNumber
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedPhoneNumber', newValue)
      }
    },
    editedCompanyName: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.companyName
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedCompanyName', newValue)
      }
    },
    editedCompanyRegistrationNumber: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.companyRegistrationNumber
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedCompanyRegistrationNumber', newValue)
      }
    },
    editedBankName: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.bankName
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedBankName', newValue)
      }
    },
    editedBankAccountName: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.bankAccountName
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedBankAccountName', newValue)
      }
    },
    editedBankAccountNumber: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.bankAccountNumber
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setEditedBankAccountNumber', newValue)
      }
    },
    editedIsDemoAccount: {
      get: function () {
        return this.$store.state.usrstomod.editedUser.isDemoAccount
      },
      set: function (newValue) {
        this.$store.commit('usrstomod/setIsDemoAccount', newValue)
      }
    },
    showLoadingAnimation: function () {
      return this.$store.state.usrstomod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.usrstomod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.usrstomod.showNoResult
    }
  },
  name: 'users'
}
</script>



// WEBPACK FOOTER //
// src/views/Users.vue